import { Platform } from '@angular/cdk/platform';
import { CdkHeaderRowDef } from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { CanColor, mixinColor } from '@angular/material/core';
import { MatTable } from '@angular/material/table';
import { Constructor } from '@mtna/core-ts';
import { RdsCodeDisplayType, RdsPercentDisplayType, RdsVariableDisplayType } from '@rds/shared-api';

import { RdsNumberFormat } from '../core/models';
import { TableRow, TabulationTable } from './models';

export class RdsTabulationTableBase {
  constructor(public _elementRef: ElementRef) {}
}

export const _RdsTabulationTableMixinBase: Constructor<CanColor> & typeof RdsTabulationTableBase = mixinColor(
  RdsTabulationTableBase,
  'primary'
);

@Component({
  selector: 'rds-c-tabulation-table',
  templateUrl: './tabulation-table.component.html',
  styleUrls: ['./tabulation-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsTabulationTableComponent extends _RdsTabulationTableMixinBase implements CanColor {
  @ViewChild(MatTable) table!: MatTable<TableRow>;

  @Input() codeDisplay: RdsCodeDisplayType = 'NAME';
  @Input() percentType: RdsPercentDisplayType = 'NONE';
  @Input() color: 'primary' | 'accent' = 'primary';
  @Input() displayPropNames: Record<RdsCodeDisplayType, Array<string>> = {
    NAME: ['name'],
    VALUE: ['codeValue'],
    BOTH: ['codeValue', 'name'],
  };
  /** The maximum number of digits after the decimal point. Default is 2. */
  @Input() maxFractionDigits: number | string = 2;
  /** The minimum number of digits after the decimal point. Default is 0. */
  @Input() minFractionDigits: number | string = 0;
  /** How the cell values are formatted. Default is NONE */
  @Input() numberFormat: RdsNumberFormat = 'NONE';

  @Input()
  get tabulation() {
    return this._tabulation;
  }
  set tabulation(t: TabulationTable | null | undefined) {
    const prevTabulation = !!this._tabulation;
    this._tabulation = t;
    if (prevTabulation && !!t) {
      // Table Headersthat use 'ngIf' (<tr mat-header-row *ngIf="">) won't rerender
      // when the values change (add subtotals), so we have to force rerender
      this.table.removeHeaderRowDef(null as unknown as CdkHeaderRowDef);
      setTimeout(() => this.table.renderRows());
    }
  }
  private _tabulation: TabulationTable | null | undefined;
  @Input() variableDisplay: RdsVariableDisplayType = 'LABEL';

  constructor(elementRef: ElementRef, public platform: Platform) {
    super(elementRef);
  }
}
